<template>
    <v-col align-self="auto" cols="12" xl="3" lg="5" md="7" sm="8">
        <v-card elevation="2" class="pb-3 px-3" :loading="loading" :disabled="loading">
            <v-card-title>{{ $t('components.LoginForm.FormTitle') }}</v-card-title>
            <v-card-subtitle>{{ $t('components.LoginForm.FormSubtitle') }}</v-card-subtitle>
            <v-card-text>
                <v-alert v-if="error" dense outlined type="error">{{ error }}</v-alert>

                <v-form ref="form" id="form" v-model="valid" @submit.prevent="confirm">
                    <v-text-field 
                        solo light
                        v-model="email" 
                        :rules="[rules.required, rules.email]"
                        :label="$t('components.LoginForm.EmailLabel')" 
                        hint="example@domain.com"
                        prepend-icon="mdi-email"/>
                    <v-text-field 
                        solo light
                        v-model="code"
                        :counter="6"
                        :label="$t('components.ResetPasswordForm.CodeLabel')" 
                        :rules="[rules.required, rules.code]"
                        hint="XXXXXX"
                        prepend-icon="mdi-lock"/>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn type="submit" form="form" color="primary" elevation="1" class="px-6" :disabled="!valid">
                    <v-icon left>mdi-account-check</v-icon>
                    {{ $t('components.LoginForm.LoginButton') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-col>
</template>

<script>
import EventBus from '@/utils/EventBus';
import AuthAPI from '@/utils/AuthAPI';

/**
 * ConfirmAccountForm component includes the required fields and functions to 
 * perform an user confirm account process. It uses the AuthAPI class to wrap 
 * AWS Cognito service.
 */
export default {
    name: 'ConfirmAccountForm',
    data: () => ({
        valid: true,
        loading: false,
        email: '',
        code: '',
        error: '',
        rules: {
            required: value => !!value || 'Required.',
            code: value => !isNaN(value) && value.length === 6 || 'Invalid code. Ex.: XXXXXX.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        }
    }),
    mounted() {
        this.code = this.$route.params.code;
    },
    methods: {
        async confirm() {
            const { email, code } = this;
            this.toggleLoading();

            const [ success, result ] = await AuthAPI.confirmAccount(email, code);
            if (success) {
                EventBus.$emit('popup', 'Account confirmed. Please relogin!');

                let route = { name: 'login' };
                this.$router.push(route);
            }

            this.error = result;
            this.toggleLoading();
        },
        toggleLoading() {
            if (this.loading) {
                this.loading = false;
                this.$refs.form.reset();
            } else this.loading = true;
        }
    }
}
</script>